import Vue from 'vue'

function eventFactory (eventName) {
  return {
    emit () {
      Vue.prototype.$bus.$emit(eventName)
    },
    on (cb) {
      Vue.prototype.$bus.$on(eventName, cb)
    }
  }
}

const paySuccess = {
  ...eventFactory('paySuccess')
}

const createOrderSuccessHook = {
  ...eventFactory('createOrderSuccess')
}
export default {
  paySuccess,
  createOrderSuccessHook
}



// WEBPACK FOOTER //
// ./src/tools/event.js